import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PlannedTransactionListDto } from '@/features/dashboard/plannedTransactions/types/PlannedTransactionListDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';

const tourPlannedTransactionsApi = {
  getTableDefinition: (tourId: string): Promise<TableDefinitionDto> =>
    fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `tours/${tourId}/planned-transactions/table-definition`,
    ),

  getAll: (
    tourId: string,
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<PlannedTransactionListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return fetchPrivateApi<PagedDto<PlannedTransactionListDto>>(
      'POST',
      `tours/${tourId}/planned-transactions/all?${params.toString()}`,
      filterCriteria,
    );
  },
};

export default tourPlannedTransactionsApi;
